import React from "react";
import "../../assets/scss/components/splash.scss";
import icon from '../../assets/images/icon-cugate.svg';
export const SplashPage: React.FC = () => {
  return (
    <div className="splash-page">
      <div className="logo-img tw-flex tw-justify-center">
        <img src={icon} alt=""/>
      </div>
      <div className="logo-txt">
        Cugate
      </div>
    </div>
  );
};

export default SplashPage;
